import React, { useEffect, useRef } from 'react';

import neurocinema from '../../../media/img/home/home_neurocinema.jpg';
import prevencion from '../../../media/img/home/home_prevencion.jpg';
import './productShowcase.scss';

const products = [
  {
    id: 1,
    logo: neurocinema,
    title: 'NEUROCINEMA PROJECT',
    description:
      "Proyecto pionero que integra neuropsicología científica en la producción audiovisual. Actualmente aplicado en la película 'Somos Reyes', analizando montaje, personajes y arousal emocional para maximizar el impacto en el espectador.",
  },
  {
    id: 2,
    logo: prevencion,
    title: 'PREVENCIÓN DEL SUICIDIO',
    description:
      'Proyecto de prevención del suicidio en adolescentes y jóvenes en Extremadura, combinando estrategias educativas, tecnológicas y comunitarias con IA y BI para la identificación temprana de señales de riesgo e intervención proactiva.',
  },
];

const ProductShowcase = () => {
  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div>
      <section className="section__products">
        <div className="products__header">
          <h1 className="content__title-backgroundDark">Nuestros Proyectos</h1>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <p className="content__text-title-backgroundDark">
            Desarrollamos proyectos innovadores que integran neuropsicología,
            tecnología e impacto social.
          </p>
        </div>
        <div className="products-container">
          {products.map((product) => (
            <div className="products-card" key={product.id}>
              <div className="products-card__icon">
                <img
                  className="products-card__image"
                  src={product.logo}
                  alt={product.title}
                />
              </div>
              <div className="products-card__content">
                <h3 className="products-card__title">{product.title}</h3>
                <p className="products-card__description">
                  {product.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="services-info__block services-info__block--link">
          <a href="/productos/products" className="services-info__link">
            Conoce más de nuestros proyectos &#8594;
          </a>
        </div>
      </section>
    </div>
  );
};

export default ProductShowcase;
